import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { isLocalDev } from './env';

const supportedLanguages = ['de', 'en', 'nl', 'fr'];

type I18nInstance = ReturnType<typeof createInstance>;

let i18nInstance: I18nInstance | null = null;

const getI18nInstance = () => {
  if (i18nInstance !== null) {
    return i18nInstance;
  }

  i18nInstance = createInstance({
    ns: ['common'],
    defaultNS: 'common',
    debug: isLocalDev,
    detection: {
      order: ['querystring', 'path', 'localStorage', 'navigator'],
    },
    backend: {
      loadPath: `/locales/[[__lng__]]/[[__ns__]].json`,
    },
    fallbackLng: 'en',
    interpolation: {
      prefix: '[[__',
      suffix: '__]]',
      escapeValue: false,
    },
    postProcess: ['phraseInContextEditor'],
    supportedLngs: supportedLanguages,
  });

  return i18nInstance;
};

const initI18nInstance = () => {
  getI18nInstance()
    .use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init()
    .catch(() => console.error('initialization of i18n failed'));
};

export { getI18nInstance, initI18nInstance, supportedLanguages };
